import { useMemo } from 'react';
import { LeadRulesEditor, type LeadRulesApi } from '@viq-admin/screens';
import { useAbility } from '../../ability/AbilityContext';
import { getCompanyLeadRules, saveCompanyLeadRules } from '../../api/leadRules';
import { listInventoryQuestions } from '../../api/discovery';

/**
 * Console wrapper for the shared lead-rules editor. Edit rights are CASL
 * `update Company` — checked directly, because console capability strings only
 * accept read:/manage:. The backend enforces the same gate.
 */
export function CompanyLeadRulesTab({ companyId }: { companyId: string }) {
  const ability = useAbility();
  const api = useMemo<LeadRulesApi>(
    () => ({
      get: () => getCompanyLeadRules(companyId),
      save: (input) => saveCompanyLeadRules(companyId, input),
      listInventoryQuestions: async () =>
        (await listInventoryQuestions(companyId)).map((q) => ({ id: q.id, text: q.text })),
    }),
    [companyId],
  );
  // Holds are staff-only (spec 2026-09-28 §6), so only the Console offers the checkbox.
  return <LeadRulesEditor api={api} canEdit={ability.can('update', 'Company')} canSetHold />;
}
